<div class="datepicker">
  <span class="datepicker__label" *ngIf="label">{{ label }}</span>
  <div class="datepicker__wraper">
    <span class="datepicker__close" *ngIf="isClose && !withoutX">&times;</span>
    <div
      class="datepicker__box"
      [class.disabled]="disable"
      tabindex="1"
      (focusin)="this.isClose = true"
      (click)="this.isClose = true"
    >
      <input
        mwlFlatpickr
        #datapicker
        [formControl]="date"
        (flatpickrOpen)="onOpen()"
        (flatpickrClose)="onClose($event)"
        [options]="startOptions"
      />
    </div>
    <div
      class="datepicker__alt-datepicker"
      [class.disabled]="disable && showIcon"
      [class.padding-left]="iconLeft && showIcon"
      [class.padding-right]="!iconLeft && showIcon"
    >
      <i
        class="icon-calendar icon-calendar_left-image"
        *ngIf="iconLeft && showIcon"
      ></i>
      <span
        class="datepicker__text"
        [style.fontSize.px]="fontSize > 14 ? 14 : fontSize"
        >{{ dateValue }}</span
      >
      <i
        class="icon-calendar icon-calendar_right-image"
        *ngIf="!iconLeft && showIcon"
      ></i>
    </div>
  </div>
</div>
